import React from 'react';
import { Button } from 'chaoskit/src/components';
import { useFeatureToggle } from '@flopflip/react-broadcast';

import footerGraphic from '../../assets/media/footer-graphic.svg';

const FooterCTA = () => {
  const isFooterCtaFreeDemoEnabled = useFeatureToggle('footerCtaFreeDemo');

  return (
    <section className="section u-contrast u-gradient--darkBlue-purple footerCTA__wrapper">
      <div className="footerCTA__grid">
        <div className="footerCTA__grid-content">
          <h3 className="u-textFluid--h2-h3">
            Avoid downtime. Use Gremlin to turn failure into resilience.
          </h3>
          <p className="u-textMedium">
            {isFooterCtaFreeDemoEnabled
              ? 'Gremlin empowers you to proactively root out failure before it causes downtime. See how you can harness chaos to build resilient systems by requesting a demo of Gremlin.'
              : 'Gremlin empowers you to proactively root out failure before it causes downtime. Use Gremlin for Free and see how you can harness chaos to build resilient systems.'}
          </p>
          <Button
            className="u-mt--large"
            url={
              isFooterCtaFreeDemoEnabled
                ? '/demo/'
                : 'https://app.gremlin.com/signup'
            }
            type="secondary"
            data-featureflag="footerCtaFreeDemo"
          >
            {isFooterCtaFreeDemoEnabled ? 'Request a Demo' : 'Use For Free'}
          </Button>
        </div>
        <div className="footerCTA__grid-image">
          <img src={footerGraphic} alt="" />
        </div>
      </div>
    </section>
  );
};

export default FooterCTA;
